import { CarType, CourierJson, TravelMode } from '../../types/bundleTypes';
import { ReactComponent as CargoBikeIcon } from '../../assets/newsvg/bike-cargo.svg';
import { ReactComponent as BikeIcon } from '../../assets/newsvg/bike.svg';
import { ReactComponent as ElectricCar } from '../../assets/newsvg/e-car.svg';
import { ReactComponent as DieselCar } from '../../assets/newsvg/d-car.svg';
import { ReactComponent as PetrolCar } from '../../assets/newsvg/p-car.svg';
import { ReactComponent as HybridCar } from '../../assets/newsvg/h-car.svg';
import React from 'react';
import './Couriers.scss';
import { User } from '../../types/userTypes';

export function CourierVehicle({
  courier,
  style,
}: {
  courier?:
    | CourierJson
    | User
    | {
        travelMode?: TravelMode;
        carType?: CarType;
      };
  style?: Record<string, any>;
}): JSX.Element | null {
  if (!courier) {
    return <></>;
  }
  if (courier.travelMode === TravelMode.BIKE) {
    if (courier.carType === CarType.CARGO_BIKE) {
      return <CargoBikeIcon style={style || { color: '#00a257' }} />;
    }
    return <BikeIcon style={style || { color: '#00a257' }} />;
  } else {
    switch (courier.carType) {
      case 'PETROL':
        return <PetrolCar style={style || { color: '#a67c52' }} />;
      case 'ELECTRIC':
        return <ElectricCar style={style || { color: '#00a257' }} />;
      case 'DIESEL':
        return <DieselCar style={style} />;
      case 'HYBRID':
        return <HybridCar style={style || { color: '#5596ff' }} />;
      default:
        return null;
    }
  }
}
